import ModalPrompt from "@/app/components/ui/Modals/Prompt";

const PurchaseOrderSendRequestModal = () => {
  return (
    <ModalPrompt
      modalId="PURCHASE_ORDER_REQUEST"
      showIcon={false}
      contentOverflow={true}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Yes, Send",
        secondaryButtonText: "Cancel",
        primaryButtonClassname:
          "px-6 cursor-pointer py-[9px] bg-sky-900 hover:bg-sky-900 rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex",
        shouldHideOnClick: true,
      }}
      title="Are you sure you want to send this PO to Vendor ?"
      content=""
    />
  );
};

export default PurchaseOrderSendRequestModal;
